// Deterministic meal-type -> brand-color mapping.
// Meal Type has no `color` field from the backend, so we derive one from the
// existing Tailwind brand palette (see tailwind.config.js) keyed by name.
const MEAL_TYPE_PALETTE = [
  '#4CAF50', // category.vegetables / primary.500
  '#FF9800', // category.mainDishes / secondary.500
  '#2196F3', // category.fish
  '#FFD54F', // category.breakfast / accent.yellow
  '#FF7043', // accent.coral
  '#3D8B40', // primary.700
  '#F57C00', // secondary.600
]

export function getMealTypeColor(name: string | null | undefined): string {
  if (!name) return MEAL_TYPE_PALETTE[0]

  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0
  }

  return MEAL_TYPE_PALETTE[hash % MEAL_TYPE_PALETTE.length]
}
